/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
import { Button, Modal, StyleGuide, List, Input, Textbox } from '@taglivros/oef_componentes'
import React, { useState } from 'react'
import { bool, func, string } from 'prop-types'
import styled from 'styled-components'
import blueArrow from '../../assets/imagens/arrow-blue.svg'
import { validacaoEmail } from '../../utils/validadores/validadores'
import { empty, isEmptyObject } from '../../utils/helpers/helpers'
import { REQUIRED_MESSAGE, EVENTOS_GA } from '../../constants'
import { useOpcionais } from '../../contexts/OpcionaisContext'
import { enviaEventoGA } from '../../utils/helpers/helpersGA'
import {
  TITLE,
  DESCRIPTION,
  INFO_DESCRIPTION,
  POR_ONDE_INDICAR,
  OPCOES,
  BOTAO_ENVIAR_EMAIL,
  DIGITE_EMAIL,
  URL_LP_LEIA_MAIS_CLUBE,
  LINKS_WHATS,
  LINK_FACEBOOK,
  INFO_DESCRIPTION_LINK,
} from './constantesMGM'
import InlineLoader from '../InlineLoader/InlineLoader'
import { BOTAO_FECHAR } from '../../containers/Opcionais/constantsCardOpcionais'

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  p, small {
    text-align: left;
  }

  li {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 10px;
    position: relative;

    a {
      padding: 0;
      width: 100%;
    }
  }

  .textbox input {
    border: none;
  }

  .etapa-email h3 {
    margin-bottom: 50px;
    max-width: 290px;
    width: 100%;
  }

  .etapa-email button {
    margin-top: 20px;
  }

  ul {
    border-bottom: 1px solid rgba( 0, 0, 0, 0.4 );
    border-radius: 0;
    box-shadow: none;
  }

  li p {
    font-size: 18px;
  }

  li::after {
    background-image: url(${blueArrow});
    background-repeat: no-repeat;
    content: "";
    height: 20px;
    max-width: 20px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: rotate( 270deg ) translateX( 50% );
    width: 100%;
  }

  h3 {
    white-space: pre-line;
  }
`

const Descricao = styled.div`
  p {
    font-size: 16px;
    margin-bottom: 22px;
    white-space: pre-line;
  }

  h3 {
    padding: 0 20px;
  }

  a {
    :link { color: #21c5e5; }
    :visited { color: #21c5e5; }
  }
`

const ModalMgm = ( { showModal, toggleModal, codigoIndicacao } ) => {
  const [ showEmail, setShowEmail ] = useState( false )
  const [ valueInput, setValueInput ] = useState( {} )
  const [ erros, setErros ] = useState( {} )
  const [ sucessos, setSucessos ] = useState( {} )
  const { enviarEmailMGM, enviandoEmailMGM, enviadoEmailMGM, setEnviadoEmailMGM } = useOpcionais()

  const indicacaoURL = `${URL_LP_LEIA_MAIS_CLUBE}?coupon=${codigoIndicacao}`

  const validador = event => {
    const { name, value } = event.target
    let validacaoErros = {}

    if ( value === '' ) {
      validacaoErros = {
        ...erros,
        [ name ]: REQUIRED_MESSAGE
      }
    } else if ( validacaoEmail( valueInput.email ) ) {
      validacaoErros = {
        ...erros,
        [ name ]: validacaoEmail( valueInput.email )
      }
    }

    setSucessos( {
      ...sucessos,
      [ name ]: empty( validacaoErros[ name ] ) && !empty( valueInput[ name ] )
    } )

    setErros( validacaoErros )
  }

  const handleChange = event => {
    const { name, value } = event.target

    setErros( {
      ...erros,
      [ name ]: null
    } )

    setSucessos( {
      ...sucessos,
      [ name ]: null
    } )

    setValueInput( {
      ...valueInput,
      [ name ]: value
    } )
  }

  const handleSubmit = () => {
    if ( !isEmptyObject( valueInput ) && valueInput.email ) {
      enviarEmailMGM( valueInput.email )
      enviaEventoGA( EVENTOS_GA.MGM.FLUXO, EVENTOS_GA.MGM.ACOES.ENVIOU_EMAIL )
    }
  }

  const onToggleModal = () => {
    toggleModal()
    setTimeout( () => {
      setEnviadoEmailMGM( false )
      setShowEmail( false )
      setValueInput( {} )
      setSucessos( {} )
      setErros( {} )
    }, 500 )
  }

  if ( !showModal ) {
    return null
  }

  return (
    <Modal
      altura="auto"
      onShowModal={ onToggleModal }
      show={ showModal }
    >
      <ModalWrapper>
        { !showEmail ?
          <>
            <h3>
              { TITLE }
            </h3>

            <Descricao>
              <p>
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ '__html': DESCRIPTION }}
                />
              </p>

              <p>
                { INFO_DESCRIPTION }<a href={ INFO_DESCRIPTION_LINK }>aqui</a>
              </p>

              <h3>
                { POR_ONDE_INDICAR }
              </h3>
            </Descricao>

            <List
              borderColor="rgba( 0, 0, 0, 0.4 )"
              itemHeight="auto"
              margin="0 auto 30px auto"
            >
              <li
                data-testid="botao-email"
                onClick={ () => {
                  setShowEmail( true )
                  enviaEventoGA( EVENTOS_GA.MGM.FLUXO, EVENTOS_GA.MGM.ACOES.EMAIL )
                } }
              >
                <div>
                  <p>
                    { OPCOES.EMAIL }
                  </p>
                </div>
              </li>

              <li
                onClick={ () => enviaEventoGA( EVENTOS_GA.MGM.FLUXO, EVENTOS_GA.MGM.ACOES.FACEBOOK ) }
              >
                <a
                  data-testid="botao-facebook"
                  href={ `${LINK_FACEBOOK}${indicacaoURL}` }
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <p>
                    { OPCOES.FACEBOOK }
                  </p>
                </a>
              </li>

              <li
                onClick={ () => enviaEventoGA( EVENTOS_GA.MGM.FLUXO, EVENTOS_GA.MGM.ACOES.WHATSAPP ) }
              >
                <a
                  data-testid="botao-whatsapp"
                  href={ StyleGuide.isMobile() ? `${LINKS_WHATS.MOBILE}${indicacaoURL}` : `${LINKS_WHATS.DESKTOP}${indicacaoURL}` }
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <p>
                    { OPCOES.WHATSAPP }
                  </p>
                </a>
              </li>
            </List>

            <div className="textbox">
              <Textbox
                buttonValue="Copiar"
                isCopy={ true }
                label="Copie seu código de indicação"
                name="textbox"
                tipo="textbox"
                value={ codigoIndicacao }
              />
            </div>

            <div>
              <Button
                fullWidth
                onClick={ () => {
                  toggleModal()
                } }
                tema={ Button.curadoria }
                testId="botao-fechar"
              >
                Fechar
              </Button>
            </div>
          </>
          :
          <div className="etapa-email">
            {enviandoEmailMGM
              ? <InlineLoader isCenter />
              : enviadoEmailMGM
                ? (
                  <>
                    <h2>E-mail enviado com sucesso!</h2>

                    <Button
                      onClick={ onToggleModal }
                      testId="botao-enviar-email"
                    >
                      { BOTAO_FECHAR }
                    </Button>
                  </>
                )
                : (
                  <>
                    <h3>
                      { DIGITE_EMAIL }
                    </h3>

                    <Input
                      erro={ erros.email }
                      label={ OPCOES.EMAIL }
                      name="email"
                      onBlur={ validador }
                      onChange={ handleChange }
                      sucesso={ sucessos.email }
                      testId="input-email"
                      value={ valueInput.email }
                    />

                    <Button
                      disabled={ erros.email || !valueInput.email }
                      onClick={ handleSubmit }
                      testId="botao-enviar-email"
                    >
                      { BOTAO_ENVIAR_EMAIL }
                    </Button>
                  </>
                )}

          </div> }
      </ModalWrapper>
    </Modal>
  )
}

ModalMgm.propTypes = {
  'codigoIndicacao': string.isRequired,
  'showModal': bool,
  'toggleModal': func.isRequired
}

ModalMgm.defaultProps = {
  'showModal': false
}

export default ModalMgm
